import { Box, Typography } from "@mui/material";

export const InstructionsPanel = () => {
  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: 2, fontSize: "1.2rem" }}>
        Instrucciones de uso:
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: 1 }}>
        1. Seleccioná tu PDF con requerimientos.
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: 1 }}>
        2. Hacé clic en <strong>Subir</strong> y esperá confirmación.
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: 1 }}>
        3. Luego iniciá el análisis para ver el progreso.
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: 1 }}>
        4. Al finalizar, podrás ver y descargar los resultados del análisis.
      </Typography>
      <Typography variant="body1" sx={{ marginTop: 2 }}>
        <strong>Formato obligatorio del PDF:</strong> Se debe escribir un requerimiento por párrafo,
        y debe respetar el siguiente prefijo <strong>“-ReqX:”</strong>, seguido de su descripción. 
        Siendo <strong>X</strong> el número del requerimiento.
      </Typography>
      <Typography variant="body2" sx={{ marginTop: 1 }}>
        Si cerrás el sitio, deberás volver a cargar el PDF y realizar el análisis.
      </Typography>
    </Box>
  );
};
